import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { Boxes, Search } from "lucide-react";
import { EmptyState, Skeleton } from "@finora/ui";
import { api } from "../../lib/api";

function formatQty(q: string, unit?: string): string {
  const n = Number(q);
  const txt = Number.isFinite(n) ? String(Math.round(n * 1000) / 1000) : q;
  const u = (unit ?? "").trim();
  return u ? `${txt} ${u.charAt(0).toUpperCase()}${u.slice(1)}` : txt;
}

export function StockTab() {
  const [search, setSearch] = useState("");
  const { data: stock, isLoading } = useQuery({
    queryKey: ["stock-levels"],
    queryFn: () => api.getStockLevels(),
  });

  const needle = search.trim().toLowerCase();
  const rows = (stock ?? []).filter(
    (s) =>
      !needle ||
      s.productName.toLowerCase().includes(needle) ||
      (s.productSku ?? "").toLowerCase().includes(needle) ||
      (s.productBarcode ?? "").toLowerCase().includes(needle),
  );

  return (
    <div className="space-y-3">
      <div className="relative w-full sm:w-96">
        <Search className="pointer-events-none absolute left-3 top-2.5 h-4 w-4 text-slate-400" aria-hidden />
        <input
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          placeholder="Pretraga po nazivu, šifri ili bar kodu..."
          className="h-9 w-full rounded-lg border border-border pl-9 pr-3 text-sm focus:border-brand focus:outline-none"
        />
      </div>
    <div className="rounded-xl border border-border bg-surface shadow-subtle">
      {isLoading ? (
        <div className="space-y-2 p-5">
          {Array.from({ length: 4 }).map((_, i) => (
            <Skeleton key={i} className="h-10 w-full" />
          ))}
        </div>
      ) : !stock || stock.length === 0 ? (
        <div className="p-5">
          <EmptyState
            icon={Boxes}
            title="Lager je prazan"
            description="Stanje lagera će se pojaviti ovde nakon prvog prijema robe."
          />
        </div>
      ) : rows.length === 0 ? (
        <p className="p-5 text-sm text-slate-400">Nema rezultata za „{search}“.</p>
      ) : (
        <table>
          <thead>
            <tr>
              <th>Šifra</th>
              <th>Artikal</th>
              <th>Magacin</th>
              <th>Količina</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((s) => (
              <tr key={`${s.productId}-${s.warehouseId}`}>
                <td className="text-slate-500">{s.productSku}</td>
                <td className="font-medium text-slate-800">{s.productName}</td>
                <td className="text-slate-500">{s.warehouseName}</td>
                <td>{formatQty(s.quantity, s.productUnit)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
    </div>
  );
}
